function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 21.5C16.299 21.5 21 16.799 21 11S16.299.5 10.5.5 0 5.201 0 11s4.701 10.5 10.5 10.5zM9 3.5v8.121l4.94 4.94 2.12-2.122L12 10.38V3.5H9z",
  fill: "#F4F6F8"
});

var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC41IDIxLjVDMTYuMjk5IDIxLjUgMjEgMTYuNzk5IDIxIDExQzIxIDUuMjAxMDEgMTYuMjk5IDAuNSAxMC41IDAuNUM0LjcwMTAxIDAuNSAwIDUuMjAxMDEgMCAxMUMwIDE2Ljc5OSA0LjcwMTAxIDIxLjUgMTAuNSAyMS41Wk05IDMuNVYxMS42MjEzTDEzLjkzOTMgMTYuNTYwN0wxNi4wNjA3IDE0LjQzOTNMMTIgMTAuMzc4N1YzLjVIOVoiIGZpbGw9IiNGNEY2RjgiLz4KPC9zdmc+Cg==";
export { SvgClock as ReactComponent };